import { Flex, Form, FormInstance, Radio, Typography } from "antd";
import { useEffect, useState } from "react";
import { RadioChangeEvent } from "antd/lib";
import { CheckCircle, XCircle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Question } from "@types";

interface Props {
  question?: Question;
  form: FormInstance;
}

export const CorrectIncorrectQuestion = ({ question, form }: Props) => {
  const [checked, setChecked] = useState(
    question?.answers?.[0]?.value ?? "correct"
  );
  const { t } = useTranslation();

  useEffect(() => {
    form.setFieldValue(["answers", 0, "isCorrect"], true);
    form.setFieldValue(["answers", 0, "value"], checked);
    // We intentionally run this only on mount to enforce an initial selection
    // without interfering with onChange handler updates.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = ({ target: { value } }: RadioChangeEvent) => {
    setChecked(value);
    form.setFieldValue(["answers", 0, "isCorrect"], true);
    form.setFieldValue(["answers", 0, "value"], value);
  };

  return (
    <Form.List
      name={["answers"]}
      initialValue={
        question?.answers || [{ isCorrect: true, value: checked }]
      }
    >
      {(fields) => (
        <>
          {fields.map(({ key, name, ...restField }) => {
            return (
              <>
                <Form.Item
                  noStyle
                  key={key}
                  {...restField}
                  name={[name, "isCorrect"]}
                  valuePropName="checked"
                >
                  <Radio.Group
                    style={{ width: "100%" }}
                    value={checked}
                    onChange={handleChange}
                    
                  >
                    <Flex justify="center">
                      <Radio
                        value={"correct"}
                        style={{ flexDirection: "column-reverse" }}
                      >
                        <div
                          style={{ width: "100px" }}
                          className={
                            checked === "correct"
                              ? "custom-radio-btn-checked"
                              : "custom-radio-btn"
                          }
                        >
                          <CheckCircle
                            color="green"
                            style={{ width: 48, height: 48 }}
                          />
                          <Typography.Title level={5} style={{ margin: 0 }}>
                            {t("forms.questions.correct")}
                          </Typography.Title>
                        </div>
                      </Radio>
                      <Radio
                        value={"incorrect"}
                        style={{ flexDirection: "column-reverse" }}
                      >
                        <div
                          style={{ width: "100px" }}
                          className={
                            checked === "incorrect"
                              ? "custom-radio-btn-checked"
                              : "custom-radio-btn"
                          }
                        >
                          <XCircle
                            color="red"
                            style={{ width: 48, height: 48 }}
                          />
                          <Typography.Title level={5} style={{ margin: 0 }}>
                            {t("forms.questions.incorrect")}
                          </Typography.Title>
                        </div>
                      </Radio>
                    </Flex>
                  </Radio.Group>
                </Form.Item>
              </>
            );
          })}
        </>
      )}
    </Form.List>
  );
};
